// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NodeId, NodeIdT, verifyNodeId } from "./node-id";

/**
 * A NodeId carried as a value.
 */
export class NodeIdValue implements flatbuffers.IUnpackableObject<NodeIdValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NodeIdValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNodeIdValue(bb: flatbuffers.ByteBuffer, obj?: NodeIdValue): NodeIdValue {
    return (obj || new NodeIdValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNodeIdValue(
    bb: flatbuffers.ByteBuffer,
    obj?: NodeIdValue,
  ): NodeIdValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NodeIdValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  nodeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startNodeIdValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeIdOffset, 0);
  }

  static endNodeIdValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_id
    return offset;
  }

  static createNodeIdValue(
    builder: flatbuffers.Builder,
    nodeIdOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    NodeIdValue.startNodeIdValue(builder);
    NodeIdValue.addNodeId(builder, nodeIdOffset);
    return NodeIdValue.endNodeIdValue(builder);
  }

  unpack(): NodeIdValueT {
    return new NodeIdValueT(this.nodeId() !== null ? this.nodeId()!.unpack() : null);
  }

  unpackTo(_o: NodeIdValueT): void {
    _o.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
  }

  unpackFields(...fields: string[]): NodeIdValueT {
    const t = new NodeIdValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    }
    return t;
  }
}

export class NodeIdValueT implements flatbuffers.IGeneratedObject {
  constructor(public nodeId: NodeIdT | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    const nodeId = this.nodeId !== null ? this.nodeId!.pack(builder) : 0;

    return NodeIdValue.createNodeIdValue(builder, nodeId);
  }

  clone(): NodeIdValueT {
    const obj = new NodeIdValueT();
    obj.nodeId = this.nodeId !== null ? this.nodeId!.clone() : null;
    return obj;
  }

  equals(other: NodeIdValueT): boolean {
    if (this.nodeId !== null && other.nodeId !== null) {
      if (!this.nodeId!.equals(other.nodeId!)) return false;
    } else if (this.nodeId !== other.nodeId) return false;
    return true;
  }
}

export function verifyNodeIdValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_id");
  } finally {
    verifier.popDepth();
  }
}
